//Custom
import czechFlag from "../media/icons/czech-flag.svg";
import englishFlag from "../media/icons/english-flag.svg";
import keyboardDown from "../media/icons/keyboard-down.svg";
import cubesaveLogoVertical from "../media/icons/cubesave-logo-vertical.svg";
import cubesaveLuggage from "../media/icons/cubesave-luggage.svg";

//Font awesome
import home from "../media/icons/fontawesome/solid/home.svg";
import timesCircle from "../media/icons/fontawesome/solid/times-circle.svg";
import arrowAltSquareUpRegular from "../media/icons/fontawesome/regular/arrow-alt-square-up.svg";
import arrowAltSquareUpSolid from "../media/icons/fontawesome/solid/arrow-alt-square-up.svg";
import backspace from "../media/icons/fontawesome/solid/backspace.svg";
import exclamationTriangle from "../media/icons/fontawesome/solid/exclamation-triangle.svg";
import cog from "../media/icons/fontawesome/solid/cog.svg";
import lockOpen from "../media/icons/fontawesome/solid/lock-open.svg";
import userLock from "../media/icons/fontawesome/solid/user-lock.svg";
import stopCircle from "../media/icons/fontawesome/solid/stop-circle.svg";
import syncAlt from "../media/icons/fontawesome/solid/sync-alt.svg";
import construction from "../media/icons/fontawesome/solid/construction.svg";
import telescope from "../media/icons/fontawesome/solid/telescope.svg";
import stopwatch from "../media/icons/fontawesome/solid/stopwatch.svg";
import server from "../media/icons/fontawesome/solid/server.svg";
import eraser from "../media/icons/fontawesome/solid/eraser.svg";
import cubeLight from "../media/icons/fontawesome/light/cube.svg";
import check from "../media/icons/fontawesome/solid/check.svg";
import creditCard from "../media/icons/fontawesome/solid/credit-card.svg";
import envelopeSquare from "../media/icons/fontawesome/solid/envelope-square.svg";
import phoneSquareAlt from "../media/icons/fontawesome/solid/phone-square-alt.svg";
import save from "../media/icons/fontawesome/solid/save.svg";
import creditCardFront from "../media/icons/fontawesome/solid/credit-card-front.svg";
import signalStream from "../media/icons/fontawesome/solid/signal-stream.svg";
import lock from "../media/icons/fontawesome/solid/lock.svg";
import truckLoading from "../media/icons/fontawesome/solid/truck-loading.svg";

export const M_Icons = {
	CZECH: czechFlag,
	ENGLISH: englishFlag,
	"cubesave-logo-vertical": cubesaveLogoVertical,
	"cubesave-luggage": cubesaveLuggage,

	home,
	"keyboard-down": keyboardDown,
	"times-circle": timesCircle,
	"arrow-alt-square-up-regular": arrowAltSquareUpRegular,
	"arrow-alt-square-up-solid": arrowAltSquareUpSolid,
	backspace,
	"exclamation-triangle": exclamationTriangle,
	cog,
	lock,
	"lock-open": lockOpen,
	"user-lock": userLock,
	"stop-circle": stopCircle,
	"sync-alt": syncAlt,
	construction,
	telescope,
	stopwatch,
	server,
	eraser,
	"cube-light": cubeLight,
	check,
	"credit-card": creditCard,
	"envelope-square": envelopeSquare,
	"phone-square-alt": phoneSquareAlt,
	save,
	"credit-card-front": creditCardFront,
	"signal-stream": signalStream,
	"truck-loading": truckLoading,
};
